import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { useTraderRoomRoutesConditions } from '../../../../Traders-Room/TradersRoomRoutes'
import { PagesIcon } from '../../../../icons/PagesIcon'
import { TickmillProductType } from '../../../../model/TickmillProductType'
import { TickmillCompaniesEnum } from '../../../../utils/companyName.utils'
import { useSessionEntity } from '../../../context/EntityContext'
import { MenuSection } from '../useMenuSections'

export const useSocialTradingMenu = (): MenuSection => {
  const { t } = useTranslation()

  const { isTradersRoomVisible } = useTraderRoomRoutesConditions()
  const entity = useSessionEntity()

  return useMemo(
    () => ({
      id: 'social-trading',
      label: t('Tabs.Social Trading'),
      icon: PagesIcon,
      path: '/dashboard/social-trading',
      condition: isTradersRoomVisible && entity === TickmillCompaniesEnum.TICKMILL_SC,
      products: [TickmillProductType.CFD],
    }),
    [t, isTradersRoomVisible, entity]
  )
}
